//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"DestinationFolder",1,0],[0,"EjectorDrawingType",1,0],[0,"EjectorPinType",1,0],[1,"EjectorPins",0,"Assemblies.SelectComponentList",0],[0,"MasterModelPartName",1,0],[0,"NameRule",1,0],[0,"RenameComponent",1,0],[0,"TemplateName",1,0],[0,"WorkingPart",1,"NXObject",0]],[[[],"AssignEjectorType",{},0,0],[[],"RemoveEjectorType",{},0,0],[[],"NewEjectorTableData",{R_:{ejectorTable:"Tooling.EjectorTableData"}},0,0],[[],"GetEjectorTableData",{R_:{ejectorTable:"Tooling.EjectorTableData"}},0,0]],[]];
SPLM.Tooling.EjectorTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.EjectorTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.EjectorTableBuilder.DrawingType = Object.freeze({
    "MasterModel" : "MasterModel", "SelfContained" : "SelfContained"});

SPLM.Tooling.EjectorTableBuilder.EjectorType = Object.freeze({
    "All" : "All", "Straight" : "Straight", "Shoulder" : "Shoulder", "Blade" : "Blade", "Sleeve" : "Sleeve", "Other" : "Other"});

export default SPLM;